module.exports = __webpack_public_path__ + "media/Video 36.51a7da34.mp4";